import React from 'react';
import Dashboard from './Component/Dashboard';

const App: React.FC = () => {
  return (
    <div className="App">
      <Dashboard />
    </div>
  );
};

export default App;
